import React from 'react';
import classNames from 'classnames';

import './ProductSortItemCallout.scss';

type ProductSortItemCalloutProps = { styleVariant?: string };

function ProductSortItemCallout ({ children, styleVariant }: React.PropsWithChildren<ProductSortItemCalloutProps>) {

	const className = classNames('ProductSortItemCallout', styleVariant && `ProductSortItemCallout--${styleVariant}`);

	return (
		<div className={className}>
			{children}
		</div>
	);

}

export default ProductSortItemCallout;
